module.exports = __webpack_public_path__ + "img/game_pc_id.5933d10d.png";